(() => {
	const track = document.querySelector('.marquee .track');
	if (!track) return;

	// ==== CONFIG ====
	const BASE_SPEED   = 40;   // px/sec constant drift
	const SCROLL_ACCEL = 0.35; // how strongly page scroll affects velocity
	const WHEEL_ACCEL  = 0.6;  // how strongly wheel deltas affect velocity
	const FRICTION     = 0.94; // 0..1 (higher = coasts longer)
	const MAX_SPEED    = 900;  // clamp velocity
	const PAUSE_OFFSCREEN = true;

	const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

	// ==== MEASURE ====
	const items = [...track.children];

	function gapPx(){
	  const s = getComputedStyle(track);
	  return parseFloat(s.columnGap || s.gap || '0');
	}
	function halfWidth() {
	  const n = Math.floor(items.length / 2);
	  let w = 0, g = gapPx();
	  for (let i = 0; i < n; i++) {
		const el = items[i];
		const rect = el.getBoundingClientRect();
		w += rect.width + (i ? g : 0);
	  }
	  return w;
	}

	let offset = 0;        // translateX in px (wrapped)
	let velocity = 0;      // user-influenced px/sec (from scroll/wheel)
	let baseDir = -1;      // -1 = left, +1 = right (follows scroll direction)
	let lastTime = performance.now();
	let rafId = null;
	let halfW = 0;

	function wrap() {
	  if (halfW <= 0) return;
	  while (offset <= -halfW) offset += halfW;
	  while (offset > 0) offset -= halfW;
	}
	function setTransform() {
	  track.style.transform = `translateX(${offset}px)`;
	}
	const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

	// ==== SCROLL-REACTIVE SPEED/DIRECTION (no dragging) ====
	let lastScrollY = window.scrollY;

	const onScroll = () => {
	  const dy = window.scrollY - lastScrollY;
	  lastScrollY = window.scrollY;
	  velocity = clamp(velocity + dy * SCROLL_ACCEL * 60, -MAX_SPEED, MAX_SPEED);
	  baseDir = dy >= 0 ? -1 : 1; // scrolling down moves left by default
	};
	window.addEventListener('scroll', onScroll, { passive: true });

	// Wheel over the marquee also affects speed/direction
	track.addEventListener('wheel', (e) => {
	  velocity = clamp(velocity + (-e.deltaY) * WHEEL_ACCEL, -MAX_SPEED, MAX_SPEED);
	  baseDir = e.deltaY >= 0 ? -1 : 1;
	}, { passive: true });

	// ==== VIEWPORT PAUSE (optional) ====
	let inView = true;
	if (PAUSE_OFFSCREEN && 'IntersectionObserver' in window) {
	  const io = new IntersectionObserver((entries) => {
		inView = entries.some(en => en.isIntersecting);
		if (inView && !rafId) { lastTime = performance.now(); rafId = requestAnimationFrame(tick); }
	  }, { threshold: 0.01 });
	  io.observe(track);
	}

	// ==== ANIMATION LOOP ====
	function tick(now) {
	  const dt = (now - lastTime) / 1000;
	  lastTime = now;

	  const drift = reduced ? 0 : BASE_SPEED * baseDir; // disable base drift if reduced motion
	  offset += (drift + velocity) * dt;

	  // apply friction only to imparted velocity
	  velocity *= Math.pow(FRICTION, Math.max(1, dt * 60));

	  wrap(); setTransform();

	  if (!PAUSE_OFFSCREEN || inView) rafId = requestAnimationFrame(tick);
	  else rafId = null;
	}

	// ==== INIT after images load (widths accurate) ====
	function initWhenReady() {
	  const imgs = track.querySelectorAll('img');
	  let loaded = 0;
	  const check = () => {
		loaded++;
		if (loaded === imgs.length) {
		  halfW = halfWidth();
		  lastTime = performance.now();
		  if (!reduced) rafId = requestAnimationFrame(tick);
		}
	  };
	  imgs.forEach(img => img.complete ? check() : img.addEventListener('load', check, { once: true }));
	  if (!imgs.length) { halfW = halfWidth(); rafId = requestAnimationFrame(tick); }
	}
	initWhenReady();
  })();
